<template>
    <div class="doc-wrapper" v-if="userProfileAge >= 18">
        <div class="row">
            <ModelSelect
                label="Вид документа"
                item-value="id"
                item-text="field_value"
                :items="docTypesToShow"
                v-model="doc.foreignDocTypeId"
            />

            <div></div>
            <div></div>
        </div>

        <div class="row">
            <ModelString
                label="Серия"
                v-model="doc.series"
                :disabled="docSeriesDisabled"
                :invalidateFunction="validateSeries"
                :mask="docSeriesMask"
                mask-placeholder="X"
            />

            <ModelString
                :class="doc.foreignDocTypeId === snilsTypeId ? 'doc_snils' : ''"
                label="Номер"
                v-model="doc.num"
                :invalidateFunction="validateNumber"
                :mask="docNumberMask"
                mask-placeholder="X"
            />

            <div></div>
        </div>

        <div class="row row-align-end">
            <div class="birthday">
                <ModelISO
                    label="Дата выдачи"
                    v-model="doc.dateOfIssue"
                    :disable="docDateOfIssueDisabled"
                    hidden-lenght-counter
                />
            </div>

            <ModelString label="Кем выдан" v-model="doc.issuer" :disabled="docIssuerDisabled" />

            <ModelString
                label="Код подразделения"
                v-model="doc.issuerCode"
                :disabled="docIssuerCodeDisabled"
                :invalidateFunction="validateIssuerCode"
                :mask="docIssuerCodeMask"
                mask-placeholder="X"
            />
        </div>

        <div class="row">
            <ModelFile
                class="edu-file"
                label="Прикрепить документ"
                data-voicetext="Прикрепить документ"
                v-model="doc.files"
                multiple
                :accept="allowedFiles.join(',')"
            />
        </div>
    </div>
</template>

<script>
import ModelString from '../../../UI/models/ModelString';
import ModelISO from '../../../UI/models/ModelISO';
import ModelSelect from '../../../UI/models/ModelSelect';
import ModelFile from '../../../UI/models/ModelFile';
import { mapActions, mapGetters } from 'vuex';

const getters = ['userProfileAge', 'dictionaryByType'];

const actions = ['loadDictionaryItems'];

export default {
    name: 'WideDoc',
    props: {
        doc: Object,
        allDocs: Array,
        docTypes: Array,
    },
    data: () => ({
        disabled: {
            series: {
                assurance: true,
                inn: true,
            },
            issuerCode: {
                inn: true,
                assurance: true,
            },
            issuer: {
                assurance: true,
            },
            dateOfIssue: {
                assurance: true,
            },
        },
        masks: {
            num: {
                assurance: '999-999-999 99',
                inn: '999999999999',
                pasport: '999999',
            },
            series: {
                pasport: '9999',
            },
            issuerCode: {
                pasport: '999999',
            },
        },
        errors: {
            series: false,
            number: false,
            issuerCode: false,
        },
        allowedFiles: ['image/png', 'image/jpeg', 'image/jpg', 'application/pdf', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
    }),
    methods: {
        ...mapActions(actions),

        validateForm() {
            this.errors.foreignDocTypeId = this.validateForeignDocTypeId(this.doc.foreignDocTypeId);
            this.errors.series = this.validateSeries(this.doc.series);
            this.errors.number = this.validateNumber(this.doc.num);
            this.errors.issuerCode = this.validateIssuerCode(this.doc.issuerCode);
        },

        validateForeignDocTypeId(val) {
            if (!val) {
                this.errors.foreignDocTypeId = true;
                return 'Некорректный тип документа';
            }
            this.errors.foreignDocTypeId = false;
            return false;
        },

        validateSeries(val) {
            if (this.doc.foreignDocTypeId === this.passportTypeId) {
                return this.validatePassportSeries(val);
            }
            return false;
        },

        validateNumber(val) {
            if (this.doc.foreignDocTypeId === this.snilsTypeId) {
                return this.validateSnilsNumber(val);
            } else if (this.doc.foreignDocTypeId === this.innTypeId) {
                return this.validateInnNumber(val);
            } else if (this.doc.foreignDocTypeId === this.passportTypeId) {
                return this.validatePassportNumber(val);
            }
            return false;
        },

        validateIssuerCode(val) {
            if (this.doc.foreignDocTypeId === this.passportTypeId) {
                return this.validatePassportIssuerCode(val);
            }
            return false;
        },

        validatePassportNumber(val) {
            const value = (val || '').replace(/[^\d]/g, '');

            if (value.length !== 6) {
                this.errors.number = true;
                return 'Некорректный номер паспорта';
            }
            this.errors.number = false;
            return false;
        },

        validatePassportSeries(val) {
            const value = (val || '').replace(/[^\d]/g, '');
            if (value.length !== 4) {
                this.errors.series = true;
                return 'Некорректная серия паспорта';
            }
            this.errors.series = false;
            return false;
        },

        validatePassportIssuerCode(val) {
            const value = (val || '').replace(/[^\d]/g, '');

            if (value.length !== 6 && value.length !== 0) {
                this.errors.issuerCode = true;
                return 'Некорректный код подразделения паспорта';
            }
            this.errors.issuerCode = false;
            return false;
        },

        validateSnilsNumber(val) {
            const value = (val || '').replace(/[^\d]/g, '');
            let error = false;


            if (value.length !== 11) {
                this.errors.number = true;
            }

            if (value.length === 11) {
                if (Math.floor(+value / 100) > 1001998) {
                    const digits = value.split('');
                    const control = +value.substring(9);
                    let result = 0;
                    for (let j = 0; j < 9; j++) {
                        result += (9 - j) * digits[j];
                    }
                    result = (result % 101) % 100;
                    if (result !== control) {
                        error = true;
                    }
                }
            } else {
                error = true;
            }

            if (value === '00000000000') {
                error = true;
            }

            this.errors.number = error;

            if (error) {
                return 'Некорректный номер СНИЛС';
            }
        },
        validateInnNumber(val) {
            const value = (val || '').replace(/[^\d]/g, '');

            if (value.length !== 10 && value.length !== 12) {
                this.errors.number = true;
                return 'Некорректный номер ИНН';
            }
            this.errors.number = false;
            return false;
        },

    },
    computed: {
        ...mapGetters(getters),

        currentDocType() {
            let v = this.dictionaryByType('docs').find((v) => v.id === this.doc.foreignDocTypeId);
            return v ? v['field_name'] : null;
        },
        docNumberMask() {
            return this.masks.num[this.currentDocType] || null;
        },
        docSeriesMask() {
            return this.masks.series[this.currentDocType] || null;
        },
        docIssuerCodeMask() {
            return this.masks.issuerCode[this.currentDocType] || null;
        },
        docSeriesDisabled() {
            return this.disabled.series[this.currentDocType] || false;
        },
        docIssuerCodeDisabled() {
            return this.disabled.issuerCode[this.currentDocType] || false;
        },
        docIssuerDisabled() {
            return this.disabled.issuer[this.currentDocType] || false;
        },
        docDateOfIssueDisabled() {
            return this.disabled.dateOfIssue[this.currentDocType] || false;
        },
        docTypesToShow() {
            const ids = this.allDocs.map((doc) => doc.foreignDocTypeId).filter((id) => id);
            return this.docTypes.filter((type) => this.doc.foreignDocTypeId === type.id || !ids.includes(type.id));
        },
        snilsTypeId() {
            const docType = this.docTypes.find((type) => type.field_name === 'assurance');
            return docType ? docType.id : null;
        },
        innTypeId() {
            const docType = this.docTypes.find((type) => type.field_name === 'inn');
            return docType ? docType.id : null;
        },

        passportTypeId() {
            const docType = this.docTypes.find((type) => type.field_name === 'pasport');
            return docType ? docType.id : null;
        },

        currentNum() {
            return this.doc.num;
        },

        hasErrors() {
            return Object.values(this.errors).filter(Boolean).length > 0;
        },
    },
    model: {
        prop: 'doc',
        event: 'change',
    },
    components: {
        ModelString,
        ModelISO,
        ModelSelect,
        ModelFile,
    },
    watch: {
        hasErrors: {
            handler(newValue) {
                this.$emit('error', this.hasErrors);
            },
            immediate: true,
        },
        currentDocType(value, oldValue) {
            if (value === 'inn') {
                this.doc.series = '';
            }
            this.validateForm();
        },
        currentNum() {
            if (this.doc.foreignDocTypeId === this.snilsTypeId) {
                this.doc.num = this.doc.num.replace(/[^\d]/g, '');
            }
        },
    },

    mounted() {
        this.validateForm();
    },
};
</script>

<style lang="scss" scoped>
@import '../../../../styles/rem';

.doc-wrapper {
    .row {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-left: unset !important;
        margin-right: unset !important;
        &-align-end {
            align-items: flex-end;
        }

        > * {
            width: rem(471);
        }
    }
}

@import '../../../../styles/variables';
@media (max-width: $vm) {
    .doc-wrapper .row {
        flex-direction: column;

        > * {
            width: 100%;
        }
    }
}
</style>
